

















import { Component, Vue } from "vue-property-decorator";
import { getTeacherCourseAttachmentUsage } from "@/api/workspace";
@Component({
  filters: {
    usedLengthTimeFilter(time: number) {
      time = time || 0;
      if (time < 60) return time + "分钟";
      else return `${Math.floor(time / 60)}小时${Math.floor(time % 60)}分钟`;
    },
  },
})
export default class HeadCourseTeaching extends Vue {
  historyListData: any = null;

  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  get showWorkspace() {
    const ifBanedUser = this.$store.state.UserModule.userInfo?.hasReviewAccount;
    return !ifBanedUser && this.loginStatus;
  }

  mounted() {
    if (this.showWorkspace)
      getTeacherCourseAttachmentUsage().then((data) => {
        this.historyListData = data
      });
  }

  toCourse() {
    if (this.historyListData.teachingAuxiliaryId) {
      this.$router.push(
        `/course/subjectDetail/${this.historyListData.courseId}?teachingAuxiliaryId=${this.historyListData.teachingAuxiliaryId}&from=2&target=resourse`
      );
    } else {
      this.$router.push(
        `/course/detail/${this.historyListData.courseId}?from=1&target=resourse`
      );
    }
  }
}
